
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/services",
      function () {
        return require("private-next-pages/[publicId]/services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/services"])
      });
    }
  